var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  height: 24,
  viewBox: "0 -960 960 960",
  width: 24
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M200-94q-43.725 0-74.863-31.137Q94-156.275 94-200v-560q0-43.725 31.137-74.862Q156.275-866 200-866h560q43.725 0 74.862 31.138Q866-803.725 866-760v560q0 43.725-31.138 74.863Q803.725-94 760-94H200Zm22-170h516L572-486 450-322l-92-122-136 180Z"
})));
export default __webpack_public_path__ + "static/media/image-placeholder-new.59b40b39.svg";
export { SvgComponent as ReactComponent };